import { render, staticRenderFns } from "./AfMarcaFormComponent.vue?vue&type=template&id=45f17c0e&"
import script from "./AfMarcaFormComponent.vue?vue&type=script&lang=js&"
export * from "./AfMarcaFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports